
import { getSVGIcon } from "~/functions"
import { Operator } from "~/types/operator"

export const thunderbird: Operator = {
	id: 'thunderbird',
	name: 'Thunderbird',
	role: 'Defender',
	org: 'STAR-NET AVIATION',
	squad: 'WOLFGUARD',
	ratings: {
		health: 2,
		speed: 2,
		difficulty: 1
	},
	meta: {
		gender: 'f',
		country: 'ca',
		season: 'Y6S2',
		height: 172,
		weight: 70,
		price: {
			renown: 10000,
			r6credits: 240
		}
	},
	bio: {
		real_name: 'Mina Sky',
		birthplace: 'Nakoda Territories, Canada'
	},
	svg: {
		contents: '<switch><foreignObject width="1" height="1" x="0" y="0" requiredExtensions="http://ns.adobe.com/AdobeIllustrator/10.0/"></foreignObject><g><path d="M45 45h260v260H45z" style="opacity:.4"></path><path d="M73 73h204v204H73z" style="fill:#7f3c32"></path><path d="M179.266 168.362V83.779l73.087-42.197v84.583z"></path><path d="M194.244 141.967V92.828l42.847-24.738v49.139z" style="fill:#fff"></path><path d="M171.303 168.362V83.779L98.216 41.582v84.583z"></path><path d="M156.325 141.967V92.828L113.478 68.09v49.139z" style="fill:#fff"></path><path d="m95.087 132.931 73 42-73 42-73-42z"></path><path d="m52.757 174.932 42.33-25.541 42.328 25.536-42.328 25.545z" style="fill:#fff"></path><path d="m254.913 132.931 73 42-73 42-73-42z"></path><path d="m212.582 174.932 42.331-25.541 42.328 25.536-42.328 25.545z" style="fill:#fff"></path><path d="M171.303 182.638v84.583l-73.087 42.197v-84.583z"></path><path d="M156.325 209.033v49.139l-42.847 24.738v-49.139z" style="fill:#fff"></path><path d="M179.266 182.638v84.583l73.087 42.197v-84.583z"></path><path d="M194.244 209.033v49.139l42.847 24.738v-49.139z" style="fill:#fff"></path><circle cx="175.284" cy="231.24" r="10.807" style="fill:#fff"></circle><circle cx="175.284" cy="118.623" r="10.807" style="fill:#fff"></circle><circle cx="175.284" cy="174.931" r="10.807" style="fill:#fff"></circle></g></switch>',
		attributes: {
			xmlns: 'http://www.w3.org/2000/svg',
			space: 'preserve',
			viewBox: '0 0 350 350',
			class: 'r6operators r6operators-thunderbird'
		}
	},
	toSVG: function(userAttr){return getSVGIcon(this, userAttr)}
}
